import { Type } from 'class-transformer';
import {
    CARE_KIT,
    ProductCategoryModel,
    ProductOptionModel,
    ProductReferenceModel,
    ProductTypes,
    SOFASHIELD,
    StockModel
} from 'models/Basket';
import { productHelper } from 'helpers';
import { ProductBaseOptionModel } from './ProductBaseOptionModel';

export class ProductModel {
    public code: string;

    public name: string | null = null;

    public range: string | null = null;

    public bcop: string;

    public scoopImage: string;

    public swatchColour: string;

    public swatchName: string;

    public brDocumentID: string;

    public swatchSample: string;

    public leadDays: string;

    public eudrCompliant: boolean;

    public webDescription: string;

    @Type(() => ProductOptionModel)
    public productOption: ProductOptionModel | null = null;

    @Type(() => StockModel)
    public stock: StockModel | null = null;

    @Type(() => ProductReferenceModel)
    public productReferences: ProductReferenceModel[];

    @Type(() => ProductCategoryModel)
    public categories: ProductCategoryModel[];

    @Type(() => ProductBaseOptionModel)
    public baseOptions: ProductBaseOptionModel[];

    public get type(): ProductTypes {
        if (this.name && (this.name.toLowerCase().includes(CARE_KIT.toLowerCase()) || this.name.toLowerCase().includes(SOFASHIELD.toLowerCase()))) {
            return productHelper.getProductTypeByName(this.name.toLowerCase());
        }

        return productHelper.getProductTypeByCode(this.code, this.categories);
    }
}